import * as actionTypes from './actionTypes';

export const setIdcard = (idcard) => {
  return {
    type: actionTypes.SET_IDCARD_IMAGE,
    idcard: idcard
  }
}